export enum DealSettingsView {
	General = 'general',
	Members = 'members',
	Classifiers = 'classifiers',
	EmailTemplates = 'email-templates',
	User = 'user',
}
